export const paymentMethodOptions = [
  {
    id: "mix",
    label: "Fiat cash and tokens",
    value: "cashAndTokens",
  },
  {
    id: "fiat-cash",
    label: "Fiat cash only",
    value: "cash",
  },
  {
    id: "tokens-only",
    label: "Tokens only",
    value: "tokens",
  },
];

export const productTypeOptions = [
  {
    id: "physical-product",
    label: "Physical",
    value: "physical",
  },
  {
    id: "digital-product",
    label: "Digital",
    value: "digital",
  },
];

export const paymentTypeOptions = [
  { id: "quickbuy", label: "Single buy", value: "quickbuy" },
  {
    id: "sub",
    label: "Subscription",
    value: "subscription",
  },
];

export const saleTypeOptions = [
  {
    id: "sales-open",
    label: "Sales open",
    value: 0,
  },
  {
    id: "pre-registration",
    label: "Pre registration",
    value: 1,
  },
];

export const splittableOptions = [
  {
    id: "splittable",
    label: "Splittable",
    value: true,
  },
  {
    id: "non-splittable",
    label: "Non splittable",
    value: false,
  },
];

export const EYE_LINE_ADS_ID = 934;



// WEBPACK FOOTER //
// ./src/screens/super_products/components/constants.js